import { c as _c } from "react/compiler-runtime";
import { addEventToDataLayerGT3 } from "@website/tracking/tracking.gtm";
import { DATA_LAYER_EVENTS } from "@website/tracking/tracking.types";
import { SnackbarSeverity } from "@website/ui/snackbar-v2";
import { datalayerAppName } from "@website/widget/telesales/constants";
import { TelesalesAppName } from "@website/widget/telesales/types";
import toNumber from "lodash-es/toNumber";
import { useState } from "react";
export const useTelesales = (storageKey, app) => {
  const $ = _c(11);
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [isSubmitBefore, setIsSubmitBefore] = useState(false);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      title: ""
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [snackbar, setSnackbar] = useState(t0);
  let t1;
  if ($[1] !== app || $[2] !== storageKey) {
    t1 = () => {
      setIsOpenModal(true);
      addEventToDataLayerGT3(DATA_LAYER_EVENTS.TELESALES_BUTTON_CLICK, {
        item: [{
          item_brand: datalayerAppName[app]
        }]
      });
      const timestamp = toNumber(localStorage.getItem(storageKey));
      setIsSubmitBefore(Boolean(timestamp) && Date.now() - timestamp <= 10800000);
    };
    $[1] = app;
    $[2] = storageKey;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const handleOpenModal = t1;
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      setSnackbar({
        title: "\u062F\u0631\u062E\u0648\u0627\u0633\u062A \u0634\u0645\u0627 \u0628\u0627 \u0645\u0648\u0641\u0642\u06CC\u062A \u062B\u0628\u062A \u0634\u062F.",
        severity: "success"
      });
    };
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const onSubmitSuccess = t2;
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => {
      setSnackbar({
        title: ""
      });
    };
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const onCloseSnackbar = t3;
  let t4;
  if ($[6] !== handleOpenModal || $[7] !== isOpenModal || $[8] !== isSubmitBefore || $[9] !== snackbar) {
    t4 = {
      isOpenModal,
      setIsOpenModal,
      handleOpenModal,
      isSubmitBefore,
      snackbar,
      onSubmitSuccess,
      onCloseSnackbar
    };
    $[6] = handleOpenModal;
    $[7] = isOpenModal;
    $[8] = isSubmitBefore;
    $[9] = snackbar;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
};